import { AutogenModelCarrierLaneRate, AutogenRowCarrierLaneRate } from "./autogen/AutogenModelCarrierLaneRate";

export class ModelCarrierLaneRate extends AutogenModelCarrierLaneRate<RowCarrierLaneRate> {
	constructor() {
		super(RowCarrierLaneRate);
	}
}

export class RowCarrierLaneRate extends AutogenRowCarrierLaneRate {
}